"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Z = exports.ZQuery = void 0;
const appFetch_1 = require("./appFetch");
const appModals_1 = require("./appModals");
class ZQuery {
    static get instance() {
        if (!ZQuery._instance) {
            if (window['Z'] === undefined)
                ZQuery._instance = new ZQuery();
            else
                ZQuery._instance = window['Z'];
        }
        return ZQuery._instance;
    }
    constructor() {
        this.domParser = new DOMParser();
        this.toFocusOnNextUpdateLayout = [];
        this.spunUpManifest = [];
        this.confirmationApproveCallback = null;
        this.confirmationDismissCallback = null;
        if (window['Z-instance-count'] === undefined)
            window['Z-instance-count'] = 0;
        window['Z-instance-count']++;
        if (window['Z-instance-count'] > 1)
            throw new DOMException('WHHHH');
        console.log(`[[ new instance of ZQuery ]]`);
        this._data = new Map();
        this.fetcher = new appFetch_1.AppFetch();
    }
    valueOfFrom(root, selector, def = null) {
        let el = exports.Z.oneFrom(root, selector);
        if (el)
            return el.value;
        return `${def || ''}`;
    }
    valueOf(selector, def = null) {
        let el = exports.Z.one(selector);
        if (el)
            return el.value;
        return `${def || ''}`;
    }
    setValue(selector, value = undefined, triggerChange = false) {
        let el = exports.Z.one(selector);
        if (el && value !== undefined) {
            el.value = value;
            if (triggerChange)
                exports.Z.trigger(el, 'change');
        }
    }
    setValues(values, triggerChange = false) {
        if (values) {
            Object.keys(values)
                .forEach(key => {
                exports.Z.setValue(key, values[key], triggerChange);
            });
        }
    }
    empty(selector) {
        exports.Z.forEach(selector, el => el.innerHTML = '');
    }
    clearValue(selector, triggerChange = false) {
        exports.Z.setValue(selector, null, triggerChange);
    }
    trigger(selector, eventType) {
        let el = exports.Z.one(selector);
        if (el) {
            el.dispatchEvent(new Event(eventType));
        }
    }
    changed(selector) {
        exports.Z.trigger(selector, 'change');
    }
    hide(selector) {
        exports.Z.forEach(selector, el => {
            el.classList.add('d-none');
        });
    }
    show(selector) {
        exports.Z.forEach(selector, el => {
            if (el.style.display.indexOf('none') !== -1) {
                el.style.display = '';
            }
            el.classList.remove('d-none');
        });
    }
    showAndFocus(selector) {
        exports.Z.show(selector);
        exports.Z.focus(selector);
    }
    showFocusAndSelect(selector) {
        exports.Z.show(selector);
        exports.Z.focusAndSelect(selector);
    }
    focus(selector) {
        exports.Z.forEach(selector, el => el.focus());
    }
    focusAndSelect(selector) {
        exports.Z.forEach(selector, el => {
            el.focus();
            if (el['select'] && typeof el['select'] === 'function')
                el['select']();
        });
    }
    getData(el, key = null) {
        //console.log(`get data[${key}] for: `, el);
        if (!this._data.has(el))
            this._data.set(el, new Map());
        if (key === null)
            return this._data.get(el);
        if (this._data.get(el).has(key))
            return this._data.get(el).get(key);
        /*if (!this._data[el])
            this._data[el] = new Map();

        if (key === null)
            return this._data[el];

        if (this._data[el][key])
            return <T>this._data[el][key];*/
        return null;
    }
    setData(el, key, val) {
        let map = this.getData(el);
        //map[key] = val;
        map.set(key, val);
        this._data.set(el, map);
        //this._data[el] = map;
        //console.log(`set data[${key}] on: `, el, val);
    }
    getParent(src, selector) {
        //let parent = src.parentElement;
        let parent = src;
        while (parent) {
            if (parent.matches(selector))
                return parent;
            parent = parent.parentElement;
        }
        return null;
    }
    init(q, id, func) {
        let lst = this.select(q);
        lst.forEach((el, index) => {
            id += `-${index}`;
            let instance = this.getData(el, id);
            if (instance) {
                //console.log(`element [${id}] is already initialised`, q, el, id, instance);
                return;
            }
            instance = func(el, index) || true;
            this.setData(el, id, instance);
        });
    }
    bind(q, event, callback) {
        this.forEach(q, el => {
            el.addEventListener(event, callback);
        });
    }
    selectFrom(root, q) {
        let ret = [];
        if (!q)
            return ret;
        if (q instanceof HTMLElement) {
            ret.push(q);
        }
        else if (typeof q === 'string') {
            let query = root.querySelectorAll(q);
            query.forEach(e => {
                ret.push(e);
            });
        }
        return ret;
    }
    any(q) {
        return exports.Z.select(q).length > 0;
    }
    indexOf(q) {
        let el = exports.Z.first(q);
        if (!el)
            return -1;
        if (!el.parentElement)
            return -1;
        for (let i = 0; i < el.parentElement.children.length; i++) {
            if (el.parentElement.children.item(i) === el)
                return i;
        }
        return -1;
    }
    select(q) {
        return this.selectFrom(document, q);
    }
    oneFrom(root, q) {
        let lst = this.selectFrom(root, q);
        return lst.length ? lst[0] : null;
    }
    one(q) {
        return this.oneFrom(document, q);
    }
    first(q) {
        let lst = this.select(q);
        return lst.length ? lst[0] : null;
    }
    last(q) {
        let lst = this.select(q);
        return lst.length ? lst[lst.length - 1] : null;
    }
    firstFrom(root, q) {
        let lst = this.selectFrom(root, q);
        return lst.length ? lst[0] : null;
    }
    lastFrom(root, q) {
        let lst = this.selectFrom(root, q);
        return lst.length ? lst[lst.length - 1] : null;
    }
    forFirstFrom(root, q, func) {
        if (!func)
            return;
        let lst = this.selectFrom(root, q);
        if (lst.length) {
            func(lst[0]);
        }
    }
    forLastFrom(root, q, func) {
        if (!func)
            return;
        let lst = this.selectFrom(root, q);
        if (lst.length) {
            func(lst[lst.length - 1]);
        }
    }
    forFirst(q, func) {
        this.forFirstFrom(document, q, func);
    }
    forLast(q, func) {
        this.forLastFrom(document, q, func);
    }
    forEachFrom(root, q, func) {
        if (!func)
            return;
        let lst = this.selectFrom(root, q);
        lst.forEach((el, ix) => {
            func(el, ix);
        });
    }
    forEach(q, func) {
        this.forEachFrom(document, q, func);
    }
    submitFormAsync(src, formSrc, onSuccess = null, onFail = null, action = null) {
        this.spinUp(src);
        exports.Z.clearInvalidFeedback();
        //let contentType = 'application/json';
        let boundary = '---------';
        while (boundary.length < 50)
            boundary += Math.floor(Math.random() * 16).toString(16);
        let contentType = `multipart/form-data; boundary=${boundary}`;
        let formData;
        if (formSrc instanceof FormData)
            formData = formSrc;
        else if (formSrc instanceof HTMLFormElement) {
            formData = new FormData(formSrc);
            action = formSrc.getAttribute('action');
            contentType = formSrc.enctype;
        }
        document.querySelectorAll('.is-invalid')
            .forEach(element => {
            element.classList.remove('is-invalid');
        });
        let xhr = new XMLHttpRequest();
        xhr.withCredentials = true;
        action = `${action || '/'}`.split('://').join('::/').split('//').join('/').split('::/').join('://');
        xhr.open('POST', action, true);
        xhr.onload = loaded => {
            //R.logIf(this.deepLog, `loaded`, loaded);
            //console.log(`xhr.onload(${action}) =>`, xhr);
            exports.Z.spinDown();
            if (xhr.status == 200) {
                let json = xhr.responseText;
                if (json.trim().startsWith('<')) {
                    exports.Z.fetcher.handleSuccessfulJsonResponse(null, onSuccess, json);
                }
                else {
                    try {
                        exports.Z.fetcher.handleSuccessfulJsonResponse(JSON.parse(json), onSuccess, json);
                    }
                    catch (ex) {
                        console.log(ex);
                        exports.Z.fetcher.handleSuccessfulJsonResponse(null, onSuccess, json);
                    }
                }
                //R.logIf(this.deepLog, `success:`, json);
            }
            else {
                //R.logIf(this.deepLog, `fail:`, xhr);
                let json = xhr.responseText;
                if (json.trim().startsWith('<')) {
                    exports.Z.fetcher.handleFailedJsonResponse(null, onFail);
                }
                else {
                    try {
                        exports.Z.fetcher.handleFailedJsonResponse(JSON.parse(json), onFail);
                    }
                    catch (ex) {
                        console.log(ex);
                        exports.Z.fetcher.handleFailedJsonResponse(null, onFail);
                    }
                }
            }
            //this.setProgressState('inactive');
        };
        xhr.onerror = error => {
            //R.logIf(this.deepLog, `error`, error);
            exports.Z.spinDown();
            let json = xhr.responseText;
            try {
                exports.Z.fetcher.handleFailedJsonResponse(JSON.parse(json), onFail);
            }
            catch (ex) {
                console.log(ex);
                exports.Z.fetcher.handleFailedJsonResponse(null, onFail);
            }
            //R.logIf(this.deepLog, `failed:`, json);
        };
        xhr.upload.onprogress = progress => {
            if (progress.lengthComputable) {
                let percentComplete = ((progress.loaded / progress.total) * 100);
                //this.setProgressState('active', percentComplete);
            }
            else {
                //this.setProgressState('indeterminate');
            }
        };
        xhr.onprogress = progress => {
        };
        xhr.send(formData);
    }
    /*handleFieldErrorResponse(fieldErrorResponse: { field: string; message: string; }) {
        console.log(`Error in field [${fieldErrorResponse.field}] [${fieldErrorResponse.message}]`);
        let input: HTMLElement;

        if (fieldErrorResponse.field.indexOf(';') !== -1) {
            let inputSelector = fieldErrorResponse.field.split(';')[0];
            let adjacentSelector = fieldErrorResponse.field.split(';')[1];

            console.log(`select adjacent field [${adjacentSelector}] from [${inputSelector}]`);

            let origin = Z.one(inputSelector);
            if (!origin)
                origin = Z.one(`[name="${inputSelector}"]`);

            console.log(` - found origin:`, origin);

            if (origin.matches(`.address-field-editor > input[type="hidden"]`)) {
                let addressField = origin.parentElement;
                console.log(` - is address field`, addressField);

                origin.classList.add('is-invalid');
                Z.forEachFrom(addressField, '.invalid-feedback', el => {
                    el.innerText = fieldErrorResponse.message;
                });

                Z.forEachFrom<HTMLInputElement>(addressField, adjacentSelector, el => {
                    el.classList.add('is-invalid');
                    el.focus();
                    if (el.select)
                        el.select();
                });

                addressField.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'center',
                });

                return;
            }

            if (origin) {
                origin = origin.parentElement;
                input = Z.oneFrom(origin, adjacentSelector);
                if (!input)
                    input = Z.oneFrom(origin, `[name="${adjacentSelector}"]`);

                console.log(` - found adjacent:`, input);
            }

        } else {
            input = Z.one(fieldErrorResponse.field);
            if (!input)
                input = Z.one(`[name="${fieldErrorResponse.field}"]`);
        }

        if (input) {
            console.log(`field:`, input);

            let validationMessage = Z.oneFrom(input.parentElement, '.invalid-tooltip, .invalid-feedback');
            console.log(`invalidMessage:`, validationMessage);

            if (validationMessage) {
                Z.setInvalidFeedback(input, fieldErrorResponse.message);
            }
        }
    }*/
    clearInvalidFeedback() {
        console.log(`clear invalid feedback`);
        exports.Z.forEach('.invalid-tooltip, .invalid-feedback', fb => {
            fb.parentElement.classList.remove('is-invalid');
            fb.classList.remove('is-invalid');
            fb.innerText = '';
        });
        exports.Z.forEach('.is-invalid', el => el.classList.remove('is-invalid'));
    }
    setInvalidFeedback(selector, message) {
        console.log(`## set invalid feedback [${message}] on [${selector}]`);
        let scrollIntoView = [];
        exports.Z.forEach(selector, el => {
            el.classList.add('is-invalid');
            el.parentElement.classList.add('is-invalid');
            //scrollIntoView.push(el);
            //scrollIntoView.push(el.parentElement);
            if (selector instanceof HTMLInputElement || selector instanceof HTMLTextAreaElement || selector instanceof HTMLSelectElement) {
                let input = selector;
                scrollIntoView.push(input);
                input.classList.add('is-invalid');
                input.focus();
                if (input['select'])
                    input.select();
            }
            else {
                exports.Z.forEachFrom(el.parentElement, 'input, textarea, select', input => {
                    if (input.classList.contains('no-vf'))
                        return;
                    input.classList.add('is-invalid');
                    //scrollIntoView.push(input);
                    input.focus();
                    if (input['select'])
                        input.select();
                });
            }
            exports.Z.forEachFrom(el.parentElement, '.invalid-tooltip, .invalid-feedback', feedback => {
                feedback.parentElement.classList.add('is-invalid');
                feedback.classList.add('is-invalid');
                feedback.innerText = message;
                //console.log('###', el);
                if (el.matches('.address-field-editor input[type="hidden"]')) {
                    scrollIntoView.push(el.parentElement);
                }
                else {
                    scrollIntoView.push(feedback);
                }
            });
        });
        console.log('scroll into view: ', scrollIntoView);
        scrollIntoView.forEach(el => {
            el.scrollIntoView({
                block: 'center',
                inline: 'center',
                behavior: 'smooth',
            });
        });
    }
    parseHtml(html) {
        if (!html)
            return null;
        let doc = this.domParser.parseFromString(html, 'text/html');
        return doc;
    }
    restyle() {
        exports.Z.forEach('link[rel="stylesheet"]', link => {
            let href = link.href;
            let newNode = document.createElement('link');
            newNode.rel = 'stylesheet';
            newNode.href = href.split('?')[0] + `?uc=${new Date().getTime()}`;
            link.replaceWith(newNode);
        });
    }
    updateLayout() {
        document.dispatchEvent(new Event('update-gui'));
    }
    pushNextFocusedElement(el) {
        if (el)
            this.toFocusOnNextUpdateLayout.push(el);
    }
    afterChangeListeners() {
        clearTimeout(this.afterChangeListenersTimeout);
        this.afterChangeListenersTimeout = setTimeout(() => {
            //console.log(`after all change listeners`);
            if (this.toFocusOnNextUpdateLayout.length) {
                let pop = this.toFocusOnNextUpdateLayout.shift();
                pop.focus();
                this.toFocusOnNextUpdateLayout = [];
            }
        }, 1);
    }
    spinUp(selector = null) {
        let els = exports.Z.select(selector);
        if (els.length) {
            for (let i = 0; i < els.length; i++) {
                let el = els[i];
                exports.Z.forEachFrom(el, 'i, svg', icon => {
                    let original = icon.outerHTML;
                    let spinnerContainer = document.createElement('span');
                    spinnerContainer.className = 'spinner-container';
                    let spinner = document.createElement('i');
                    spinner.classList.add('fas', 'fa-fw', 'fa-spinner-third', 'fa-spin');
                    spinnerContainer.appendChild(spinner);
                    icon.replaceWith(spinnerContainer);
                    if (el && el.matches('a, button, input')) {
                        el.disabled = true;
                    }
                    this.spunUpManifest.push({ icon, original, src: el, spinner, container: spinnerContainer });
                });
            }
        }
        else {
            document.body.classList.add('spun-up');
        }
    }
    spinDown() {
        document.body.classList.remove('spun-up');
        while (this.spunUpManifest.length) {
            let pop = this.spunUpManifest.pop();
            //console.log(`spin down`, pop);
            if (pop.container) {
                if (pop.original) {
                    pop.container.outerHTML = pop.original;
                }
                else {
                    pop.spinnerContainer.remove();
                }
            }
            if (pop.src && pop.src.matches('a, button, input')) {
                pop.src.disabled = false;
            }
        }
    }
    restrictInputCharacters(el, restriction = '0123456789 +*()') {
        exports.Z.init(el, 'restricted-characters', el => {
            el.addEventListener('input', ev => {
                let val = '';
                for (let i = 0; i < el.value.length && i < 4; i++) {
                    if (restriction.indexOf(el.value[i]) !== -1) {
                        val += el.value[i];
                    }
                }
                if (el.value != val) {
                    el.value = val;
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            });
        });
    }
    parseHtmlAsTemplate(html) {
        if (html.indexOf(`<html`) !== -1) {
            let document = exports.Z.domParser.parseFromString(html, 'text/html');
            return document.body.firstElementChild;
        }
        let template = document.createElement('template');
        template.innerHTML = `${html}`.trim();
        return template.content.firstChild;
    }
    dismissModal(selector = null, andThen = null) {
        if (selector === null) {
            exports.Z.forEach('.modal.show', el => exports.Z.dismissModal(el, andThen));
        }
        else {
            //let modal = selector ? document.querySelector(selector) : document.querySelectorAll('.modal.show')[0];
            let modal = exports.Z.one(selector);
            if (modal) {
                let modalObject = appModals_1.AppModal.getInstance(modal);
                if (modalObject) {
                    modalObject.bsModal.hide();
                    if (andThen)
                        andThen();
                }
            }
        }
    }
    showModal(selector, andThen = null, src = null, afterShown = null) {
        //
        appModals_1.AppModal.showModal(selector, andThen, src, afterShown);
    }
    go(src, href = null) {
        if (href === null && typeof src === 'string') {
            exports.Z.spinUp(null);
            location.href = src;
        }
        else {
            exports.Z.spinUp(src);
            location.href = href;
        }
    }
    reload(src = null) {
        exports.Z.spinUp(src);
        location.reload();
    }
    get(src, href, onSuccess = null, onFail = null) {
        exports.Z.fetcher.get(src, href, onSuccess, onFail);
    }
    confirmationDialogCancelled() {
        if (this.confirmationDismissCallback) {
            let cancelButton = document.querySelector('#confirmation-dialog .modal-footer .cancel-button');
            let result = this.confirmationDismissCallback(cancelButton);
            if (result === undefined)
                this.dismissModal('#confirmation-dialog');
            this.confirmationDismissCallback = null;
            return;
        }
        this.dismissModal('#confirmation-dialog');
    }
    confirmationDialogApproved() {
        if (this.confirmationApproveCallback) {
            let approveButton = document.querySelector('#confirmation-dialog .modal-footer .approve-button');
            let result = this.confirmationApproveCallback(approveButton);
            if (result === undefined)
                this.dismissModal('#confirmation-dialog');
            this.confirmationApproveCallback = null;
            return;
        }
        this.dismissModal('#confirmation-dialog');
    }
    confirm(opts = {}) {
        console.log(`Z.confirm`, opts);
        exports.Z.dismissModal();
        if (!opts.class)
            opts.class = 'warning';
        if (!opts.icon)
            opts.icon = 'exclamation-triangle';
        if (!opts.dismissText)
            opts.dismissText = 'Cancel';
        if (!opts.confirmText)
            opts.confirmText = 'Confirm';
        if (!opts.prompt)
            opts.prompt = 'Confirmation';
        if (opts.lock === undefined)
            opts.lock = false;
        let modal = document.querySelector('#confirmation-dialog');
        //let modalObj = R.$(modal).modal;// as bootstrap.Modal;
        let modalObj = appModals_1.AppModal.getInstance(modal).bsModal;
        modal.querySelector('.modal-header .m-icon').innerHTML = `<i class="fas fa-fw fa-${opts.icon}"></i>`;
        modal.querySelector('.modal-dialog')
            .classList
            .remove('modal-primary', 'modal-secondary', 'modal-success', 'modal-danger', 'modal-warning', 'modal-info', 'modal-light', 'modal-dark');
        modal.querySelector('.modal-dialog')
            .classList.add(`modal-${opts.class}`);
        modal.querySelector('.modal-header .m-label')
            .innerHTML = opts.prompt;
        modal.querySelectorAll('.approve-button, .cancel-button')
            .forEach(el => el.classList.remove('d-none'));
        if (opts.lock) {
            modal.classList.add('modal-static');
            modalObj._config.backdrop = 'static';
            modalObj._config.keyboard = false;
            modal.querySelector('.cancel-button')
                .classList.add('d-none');
        }
        else {
            modal.classList.remove('modal-static');
            modalObj._config.backdrop = true;
            modalObj._config.keyboard = true;
            modal.querySelector('.cancel-button')
                .classList.remove('d-none');
        }
        if (opts.confirmButton === false) {
            modal.querySelector('.approve-button')
                .classList.add('d-none');
        }
        if (opts.dismissButton === false) {
            modal.querySelector('.cancel-button')
                .classList.add('d-none');
        }
        modal.querySelector('.cancel-button .label')
            .innerHTML = opts.dismissText;
        modal.querySelector('.approve-button .label')
            .innerHTML = opts.confirmText;
        modal.querySelector('.modal-body')
            .innerHTML = opts.text || '';
        exports.Z.confirmationApproveCallback = opts.onConfirm;
        exports.Z.confirmationDismissCallback = opts.onDismiss;
        let modalDiv = exports.Z.one('#confirmation-dialog');
        if (modalDiv.matches('.fade') && !modalDiv.matches('.show')) {
            setTimeout(() => {
                exports.Z.showModal('#confirmation-dialog', modal => {
                    //R.logIf(this.deepLog, `confirmation dialog`, modal);
                    exports.Z.forEachFrom(modal, '.modal-footer .btn', btn => btn.focus());
                });
            }, 500);
        }
        else {
            exports.Z.showModal('#confirmation-dialog', modal => {
                //R.logIf(this.deepLog, `confirmation dialog`, modal);
                exports.Z.forEachFrom(modal, '.modal-footer .btn', btn => btn.focus());
            });
        }
    }
    outOfBounds(el, x, y) {
        return !exports.Z.withinBounds(el, x, y);
    }
    withinBounds(el, x, y) {
        if (!el)
            return false;
        let bounds = el.getBoundingClientRect();
        let left = Math.round(bounds.left);
        let top = Math.round(bounds.top);
        let right = left + Math.round(bounds.width);
        let bottom = top + Math.round(bounds.height);
        //R.logIf(this.deepLog, `test if [${x}, ${y}] in bounds: [${left}, ${top}; ${bounds.width}x${bounds.height} => ${right}, ${bottom}]`);
        if (x < left) {
            //R.logIf(this.deepLog, `=> no: x(${x}) left of ${left}`);
            return false;
        }
        if (y < top) {
            //R.logIf(this.deepLog, `=> no: y(${y}) above ${top}`);
            return false;
        }
        if (x > right) {
            //R.logIf(this.deepLog, `=> no: x(${x}) right of ${right}`);
            return false;
        }
        if (y > bottom) {
            //R.logIf(this.deepLog, `=> no: y(${y}) below ${bottom}`);
            return false;
        }
        //R.logIf(this.deepLog, `=> yes`);
        return true;
    }
    matches(src, compare, exact = false) {
        if (exact) {
            if (src instanceof HTMLElement) {
                if ((exports.Z.valueOf(src) + '').toString() == `${compare}`)
                    return true;
                return false;
            }
            else {
                return src === compare;
            }
        }
        else {
            if (src instanceof HTMLElement) {
                if ((exports.Z.valueOf(src) + '').toString().toLowerCase() == `${compare}`.toLowerCase())
                    return true;
                return false;
            }
            else {
                return `${src}`.toLowerCase().trim() == `${compare}`.toLowerCase().trim();
            }
        }
        return false;
    }
    showIf(src, compare, selector, andFocus = null) {
        if (exports.Z.matches(src, compare)) {
            exports.Z.show(selector);
            if (andFocus === true) {
                exports.Z.focusAndSelect(selector);
            }
            else if (andFocus !== null) {
                exports.Z.focusAndSelect(selector);
            }
        }
        else {
            exports.Z.hide(selector);
        }
    }
    hideIf(src, compare, selector) {
        if (exports.Z.matches(src, compare)) {
            exports.Z.hide(selector);
        }
        else {
            exports.Z.show(selector);
        }
    }
    showOnlyIf(src, match, element) {
        let myVal = (exports.Z.valueOf(src) || '').toString().toLowerCase();
        match = ('' + match).toLowerCase();
        if (match == myVal)
            exports.Z.show(element);
        else
            exports.Z.hide(element);
    }
    hideOnlyIf(src, match, element) {
        let myVal = (exports.Z.valueOf(src) || '').toString().toLowerCase();
        match = ('' + match).toLowerCase();
        if (match == myVal)
            exports.Z.hide(element);
        else
            exports.Z.show(element);
    }
}
exports.ZQuery = ZQuery;
exports.Z = ZQuery.instance;
window['Z'] = exports.Z;
//# sourceMappingURL=query.js.map